import { RoleChipValue } from "../components/chips/role-chip";
import { User, UserType } from "../types";
import { userHasPermission } from "../types-helpers";

// wont have to use this if using new types and do server side role checking
export const getTeamRoleInfo = (user: User, teamId: string): RoleChipValue => {
  const isClientAdmin = userHasPermission(UserType.SysAdmin, user);

  if (isClientAdmin) {
    return "Client Admin";
  }

  const isTeamAdmin = Boolean(teamId) && user.adminIds.includes(teamId);
  if (isTeamAdmin) {
    return "Team Admin";
  }

  if (user.userType === UserType.Guest) return "Guest";
  if (user.userType === UserType.Blocked) return "Blocked";
  if (user.userType === UserType.Inactive) return "Past Member";

  return "Member";
};
